import LinkExpire from '../../pages/LinkExpire/LinkExpire';
import Order from '../../pages/order/Order';
import OrderSuccess from '../../pages/OrderSuccess/OrderSuccess';
import UserInformation from '../../pages/user-info/UserInfo';
import Verifying from '../../pages/VerifySuccess/Verifying';
import VerifySuccess from '../../pages/VerifySuccess/VerifySuccess';

export const ROUTES_CONSTANTS = [
  {
    path: '/',
    component: Order,
  },
  {
    path: '/bot',
    component: Order,
  },
  {
    path: '/user-info',
    component: UserInformation,
  },
  {
    path: '/order-success',
    component: OrderSuccess,
  },
  {
    path: '/redirect/:token',
    component: Verifying,
  },
  {
    path: '/verify-success',
    component: VerifySuccess,
  },
  {
    path: '/link-expire',
    component: LinkExpire,
  },
];
